import { GroupByMode } from 'shared/types/sorting-mode';

import { GroupByMenuOptions } from './menu-options';

export const groupByOptions: GroupByMenuOptions[] = [
  {
    id: GroupByMode.None,
    value: GroupByMode.None,
    label: `pages.goals.group-by.label.${GroupByMode.None}`,
  },
  {
    id: GroupByMode.LifeArea,
    value: GroupByMode.LifeArea,
    label: `pages.goals.group-by.label.${GroupByMode.LifeArea}`,
  },
];
